import { useMemo } from 'react';

import TaskDetailComponent from '@components/task-detail-component/index';
import Icon from '@components/icon-component';

import { PERMISSIONS } from 'permissions/constants';
import { decodeToken } from '@utilities/authentication';

import style from './style.module.scss';

const EquipmentTask = ({
  setAllTask,
  setWorkOrder,
  setInspections,
  setChecks,
  allWorkOrderForSite,
  allDoneWorkOrder,
  allInspectionForSite,
  allDoneInspection,
  allTasksForSite,
  allDoneTasks,
  isOverDue,
  isCheckOverDue,
  isInspectionOverDue,
  isWorkOrderOverDue,
  allCheckForSite,
  allDoneChecks,
  newWorkRequestList = [],
  setWorkRequest,
  allOnDemandRecordCount = 0,
  newWorkOrderList,
  newChecksList,
  newInspectionList,
  allEditEquipmentAssets = [],
  setNewOrEditAssets,
  card: Card = () => <></>
}) => {
  const { iconName, taskName } = useMemo(() => {
    let showAllTasksAndRecordsTab = false,
      showAllTasksTab = false,
      showAllRecordTab = false,
      iconName = '',
      taskName = '';

    (showAllTasksAndRecordsTab =
      allOnDemandRecordCount > 0 && allTasksForSite?.length > 0 ? true : false),
      (showAllTasksTab =
        allOnDemandRecordCount === 0 && allTasksForSite?.length > 0 ? true : false),
      (showAllRecordTab =
        allOnDemandRecordCount > 0 && allTasksForSite?.length === 0 ? true : false);

    if (showAllRecordTab) iconName = 'on-demand-indicator-circle';
    else if (showAllTasksTab) {
      iconName =
        allDoneTasks?.length === allTasksForSite?.length
          ? 'all-task-completed-bag'
          : allDoneTasks?.length > 0 && allTasksForSite?.length > allDoneTasks?.length
          ? 'some-task-completed-bag'
          : 'no-task-completed-bag';
    } else if (showAllTasksAndRecordsTab) {
      iconName =
        allDoneTasks?.length === allTasksForSite?.length
          ? 'task-record-all-task-completed'
          : allDoneTasks?.length > 0 && allTasksForSite?.length > allDoneTasks?.length
          ? 'task-record-some-task-completed'
          : 'task-record-no-task-completed';
    }

    taskName = showAllTasksAndRecordsTab
      ? 'All tasks + records'
      : showAllTasksTab
      ? 'All tasks'
      : showAllRecordTab
      ? 'All records'
      : '';

    return {
      iconName,
      taskName
    };
  }, [allOnDemandRecordCount, allTasksForSite]);

  const taskDetail = [
    {
      img: <Icon name={'ins'} />,
      taskName: 'Inspections',
      btnText: `${allDoneInspection.length}/${allInspectionForSite.length}`,
      click: () => setInspections(true),
      allDoneTasks: allDoneInspection,
      allTasksForSite: allInspectionForSite,
      isOverDue: isInspectionOverDue,
      dot: !!isInspectionOverDue && allDoneInspection?.length !== allInspectionForSite?.length,
      recordCount: newInspectionList?.length || 0,
      notShowInProgressCount:
        allDoneInspection?.length > 0 || allInspectionForSite.length > 0 ? false : true
    },
    {
      img: <Icon name={'work-orders'} />,
      taskName: 'Work orders',
      btnText: `${allDoneWorkOrder?.length}/${allWorkOrderForSite?.length}`,
      click: () => setWorkOrder(true),
      allDoneTasks: allDoneWorkOrder,
      allTasksForSite: allWorkOrderForSite,
      isOverDue: isWorkOrderOverDue,
      dot: !!isWorkOrderOverDue && allDoneWorkOrder?.length !== allWorkOrderForSite?.length,
      recordCount: newWorkOrderList?.length || 0,
      notShowInProgressCount:
        allDoneWorkOrder?.length > 0 || allWorkOrderForSite.length > 0 ? false : true
    },
    {
      img: <Icon name={'check-grey'} />,
      taskName: 'Checks',
      btnText: `${allDoneChecks?.length}/${allCheckForSite?.length}`,
      click: () => setChecks(true),
      allDoneTasks: allDoneChecks,
      allTasksForSite: allCheckForSite,
      isOverDue: isCheckOverDue,
      dot: !!isCheckOverDue && allDoneChecks?.length !== allCheckForSite?.length,
      recordCount: newChecksList?.length || 0,
      notShowInProgressCount: allDoneChecks?.length > 0 || allCheckForSite.length > 0 ? false : true
    },

    {
      img: <Icon name={'work-orders'} />,
      taskName: 'Work requests',
      btnText: `${newWorkRequestList?.length}`,
      click: () => setWorkRequest(true),
      allDoneTasks: [],
      allTasksForSite: newWorkRequestList,
      isOverDue: false,
      dot: false,
      notShowInProgressCount: false
    },
    {
      img: <Icon name={'new-or-edit-assets-icon'} />,
      taskName: 'New or edited assets',
      btnText: `${allEditEquipmentAssets?.length}`,
      click: () => setNewOrEditAssets(true),
      allDoneTasks: [],
      allTasksForSite: allEditEquipmentAssets,
      isOverDue: false,
      dot: false,
      notShowInProgressCount: false
    }
  ];

  const allTasksAndRecordsChips = {
    img: <Icon name={iconName} />,
    taskName: taskName,
    btnText: `${allDoneTasks.length}/${allTasksForSite.length}`,
    click: () => setAllTask(true),
    allDoneTasks: allDoneTasks,
    allTasksForSite: allTasksForSite,
    isOverDue: isOverDue,
    dot: !!isOverDue && allDoneTasks?.length !== allTasksForSite?.length,
    recordCount: allOnDemandRecordCount,
    notShowInProgressCount: allDoneTasks?.length > 0 || allTasksForSite.length > 0 ? false : true
  };

  return (
    <div id="tasks-info-tab" style={{ overflow: 'auto' }} className={style.testing}>
      {Card ? <Card /> : <></>}

      <div className={style.allTasksAndRecordsContainer}>
        <TaskDetailComponent
          task={allTasksAndRecordsChips.taskName}
          onClick={allTasksAndRecordsChips.click}
          {...allTasksAndRecordsChips}
        />

        <div className={style.byType}>
          <p>By type</p>
        </div>
      </div>
      <div className={style.addMarginBottom}>
        {taskDetail
          ?.filter(({ taskName }) => {
            const permissions = decodeToken()?.permissions || {};
            if (taskName === 'Checks' && !permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS])
              return false;
            if (taskName === 'Inspections' && !permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS])
              return false;
            if (taskName === 'Work orders' && !permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS])
              return false;
            if (
              taskName === 'Work requests' &&
              !permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
            )
              return false;
            if (
              taskName === 'New or edited assets' &&
              !(
                permissions[PERMISSIONS.EQUIPMENT_EDIT] || permissions[PERMISSIONS.EQUIPMENT_CREATE]
              )
            )
              return false;
            return true;
          })
          .filter((a) => a.allTasksForSite?.length > 0 || a?.recordCount > 0)
          .map((ele, index) => {
            return ele.taskName === 'All Tasks' &&
              taskDetail?.filter((a) => a.allTasksForSite.length > 0).length === 2 ? (
              <></>
            ) : (
              <TaskDetailComponent
                key={index}
                task={ele.taskName}
                onClick={ele.click}
                showBorderOnTop={!index}
                {...ele}
              />
            );
          })}
      </div>
    </div>
  );
};

export default EquipmentTask;
